/**
 * startMarkerRaceLabel.js — Adapted for RaceProX
 *
 * Uses circuitAdapter.formatCircuitRaceInfo instead of nascarCircuits.
 */
import { createCornerTurnLabel3d } from './cornerTurnLabel3d.js';
import { computeMarkerLabelOffsetY } from './markerCornerLabel.js';
import { formatCircuitRaceInfo } from './circuitAdapter.js';

/** Matches buildStartMarker corner marker options. */
const START_MARKER_RING_RADIUS = 0.2;

/**
 * @param {number} labelScale
 */
export function computeStartMarkerRaceLabelOffsetY(labelScale) {
  return computeMarkerLabelOffsetY({
    cornerRingRadius: START_MARKER_RING_RADIUS,
    cornerBeamHeight: 4,
    cornerLabelScale: labelScale,
  });
}

/**
 * @param {THREE.Group} marker
 * @param {import('./circuitAdapter.js').HologramCircuit} circuit
 * @param {number} labelScale
 */
export function attachStartMarkerRaceLabel(marker, circuit, labelScale) {
  disposeStartMarkerRaceLabel(marker);

  const api = createCornerTurnLabel3d();
  api.setContent(formatCircuitRaceInfo(circuit));
  api.setScale(labelScale);
  api.object.position.set(0, computeStartMarkerRaceLabelOffsetY(labelScale), 0);
  api.object.visible = true;
  marker.add(api.object);
  marker.userData.raceLabel = api;
}

/**
 * @param {THREE.Group} marker
 * @param {import('./circuitAdapter.js').HologramCircuit} circuit
 */
export function updateStartMarkerRaceLabel(marker, circuit) {
  const api = marker.userData.raceLabel;
  if (!api) return;
  api.setContent(formatCircuitRaceInfo(circuit));
}

/**
 * @param {THREE.Group} marker
 * @param {number} labelScale
 */
export function applyStartMarkerRaceLabelScale(marker, labelScale) {
  const api = marker.userData.raceLabel;
  if (!api) return;
  api.setScale(labelScale);
  api.object.position.y = computeStartMarkerRaceLabelOffsetY(labelScale);
}

/**
 * @param {THREE.Group} marker
 */
export function disposeStartMarkerRaceLabel(marker) {
  const api = marker.userData.raceLabel;
  if (!api) return;
  if (api.object.parent) {
    api.object.parent.remove(api.object);
  }
  api.dispose();
  delete marker.userData.raceLabel;
}
